import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IMessageTemplate } from '@clickersphere/core/entities/IMessageTemplate';
import MessageTemplateService from '@clickersphere/core/services/MessageTemplateService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const MESSAGE_TEMPLATES_QUERY_KEY = 'message-templates';

export type MessageTemplateQueryData = WithQueryStatus<IMessageTemplate>;

export function useMessageTemplates() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: messageTemplates,
    isSuccess: isMessageTemplatesSuccess,
    isFetching: isMessageTemplatesFetching,
    isLoading: isMessageTemplatesLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(MESSAGE_TEMPLATES_QUERY_KEY),
    queryFn: async () => {
      const result = await MessageTemplateService.getAll();
      return result as MessageTemplateQueryData[];
    },
    select: (data) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
  });

  return {
    messageTemplates: messageTemplates ?? [],
    isMessageTemplatesSuccess,
    isMessageTemplatesFetching,
    isMessageTemplatesLoading,
  };
}
